import locale from './locale'
import modalRegistrationClosed, {
  changeModalRegistrationStatus,
  closeModalRegistrationClosed
} from './modal-registration-closed'

export { changeModalRegistrationStatus, closeModalRegistrationClosed }

export default { locale, modalRegistrationClosed }
